module.exports = __webpack_public_path__ + "img/3.21d3eb4f.jpg";